App.controller('FacilitiesCtrl', ['$scope', '$sce', '$state', '$http', function ($scope, $sce, $state, $http) {
    
}]);